import { render, staticRenderFns } from "./ReceiptImagePopup.vue?vue&type=template&id=61cd6477&scoped=true"
import script from "./ReceiptImagePopup.vue?vue&type=script&lang=js"
export * from "./ReceiptImagePopup.vue?vue&type=script&lang=js"
import style0 from "./ReceiptImagePopup.vue?vue&type=style&index=0&id=61cd6477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd6477",
  null
  
)

export default component.exports